import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const WelcomeHero = () => {
  const marketStats = [
    {
      label: 'Active Users',
      value: '50,000+',
      icon: 'Users',
      trend: '+12%'
    },
    {
      label: 'Assets Tracked',
              value: '₹207.5B+',
      icon: 'DollarSign',
      trend: '+8%'
    },
    {
      label: 'Daily Trades',
      value: '15,000+',
      icon: 'TrendingUp',
      trend: '+15%'
    }
  ];

  const features = [
    'Real-time portfolio tracking',
    'Advanced analytics & insights',
    'Secure data encryption',
    'Mobile-first design',
    'Expert market analysis',
    '24/7 customer support'
  ];

  return (
    <div className="space-y-8">
      {/* Hero Header */}
      <div className="text-center space-y-4">
        <div className="flex items-center justify-center space-x-3 mb-6">
          <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
            <Icon name="TrendingUp" size={24} color="white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">StockTracker Pro</h1>
            <p className="text-sm text-muted-foreground">Professional Portfolio Management</p>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-foreground">
          Take Control of Your Financial Future
        </h2>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Join thousands of investors who trust StockTracker Pro for comprehensive 
          portfolio management and real-time market insights.
        </p>
      </div>

      {/* Hero Image */}
      <div className="relative">
        <div className="aspect-video rounded-xl overflow-hidden bg-gradient-to-br from-primary/10 to-secondary/10">
          <Image
            src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop"
            alt="Financial dashboard with charts and graphs showing portfolio performance"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
        
        {/* Floating Stats */}
        <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-full max-w-sm">
          <div className="bg-card border border-border rounded-lg p-4 shadow-lg">
            <div className="grid grid-cols-3 gap-4">
              {marketStats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="flex items-center justify-center mb-1">
                    <Icon name={stat.icon} size={16} className="text-primary" />
                  </div>
                  <div className="text-sm font-bold text-foreground">{stat.value}</div>
                  <div className="text-xs text-muted-foreground">{stat.label}</div>
                  <div className="text-xs text-success">{stat.trend}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Features List */}
      <div className="mt-12">
        <h3 className="text-lg font-semibold text-foreground mb-4 text-center">
          Why Choose StockTracker Pro?
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center space-x-3">
              <div className="flex-shrink-0 w-5 h-5 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name="Check" size={12} className="text-success" />
              </div>
              <span className="text-sm text-muted-foreground">{feature}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonial */}
      <div className="bg-muted/30 rounded-lg p-6">
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="Quote" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm text-foreground mb-2">
              "StockTracker Pro has transformed how I manage my investments. 
              The real-time insights and intuitive interface make portfolio 
              management effortless."
            </p>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center">
                <Icon name="User" size={14} />
              </div>
              <div>
                <p className="text-xs font-medium text-foreground">Sarah Johnson</p>
                <p className="text-xs text-muted-foreground">Portfolio Manager</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Current Date */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          Market data as of {new Date().toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </p>
      </div>
    </div>
  );
};

export default WelcomeHero;